/**
 * Cleanup effect for forms
 */

import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* unloadForm3(action) {
  var payload = {
    action: "portal/unloadForm3",
    formDataId: action.formDataId,
  };

  yield put(serverRequest(payload));
}

export default unloadForm3;
